import React from 'react';
import { AvailabilityItemType, RoomAvailabilityType } from '../../types.ts';
import DateDays from './_components/DateDays';
import TableList from './_components/TableList';
import { StyledTH } from './styled.ts';
import { styled } from 'styled-components';

const StyledTR = styled.tr`
  background-color: grey !important;
  border: 2px solid grey !important;
  border-bottom: 3px solid gray !important;
`;

interface AvailabilityTableProps {
  liveAvailabilityItems: AvailabilityItemType[];
}

const AvailabilityTable: React.FC<AvailabilityTableProps> = ({ liveAvailabilityItems }) => {
  return (
    <table className="table custom-itinerary-table table-responsive">
      <thead>
        <StyledTR>
          <StyledTH>Accommodation</StyledTH>
          <StyledTH>Destination</StyledTH>
          <StyledTH>PPPN Rack Rate (Public Rate)</StyledTH>
          <StyledTH>Room Type</StyledTH>
          {liveAvailabilityItems?.length > 0 &&
            liveAvailabilityItems[0]?.Rooms[0]?.Availability?.map(
              (availability: RoomAvailabilityType, index: number) => (
                <DateDays key={`roomsAvailability_${index + 1}`} availability={availability} />
              ),
            )}
        </StyledTR>
      </thead>

      {liveAvailabilityItems?.length > 0 &&
        liveAvailabilityItems.map((liveAvailabilityItem: AvailabilityItemType, i: number) => (
          <TableList
            liveAvailabilityItem={liveAvailabilityItem}
            key={`AvailabilityItems_${i + 1}`}
          />
        ))}
    </table>
  );
};

export default AvailabilityTable;
